import { Component, Input, OnInit } from '@angular/core';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { AppDataService, MerchantUserService } from 'app/services';
import { Utils } from 'app/utils';
import { MerchantUserRolesEnum, TypeMerchantUserEnum } from 'app/models';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'partner-mart-locations-employee',
    templateUrl: './partner-mart-locations-employee.component.html',
    styleUrls: ['./partner-mart-locations-employee.component.scss'],
    providers: [MessageService]
})
export class PartnerMartLocationsEmployeeComponent implements OnInit {

    ngOnInit(): void {
    }

    @Input()
    public storeId: number = 0;

    @Input()
    public store: any = {};

    constructor(
        private messageService: MessageService,
        private appData: AppDataService,
        private merchantUserService: MerchantUserService) {
        this.handleCreatePopupHide = this.handleCreatePopupHide.bind(this);
    }

    // Grid settings
    public cols: any[] = [
        { field: 'UserId', header: 'Employee ID', width: '20%' },
        { field: 'CreatedAt', header: 'Created', width: '20%' },
        { field: 'UserName', header: 'Name', width: '20%' },
        { field: 'RoleName', header: 'Role', width: '20%' },
        { field: 'StoreName', header: 'Location', width: '20%' },
    ];

    public rowsPerPage: number = 50;
    public rowsPerPageOptions: Array<number> = [50, 100, 500, 1000];
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;

    public storeEmployees: any[] = [];
    public selectedUsers: any;
    public selectedUser: any = {};

    public searchName: string = '';
    private searchTimer: number = 0;

    public loading: boolean = false;

    public menuTab = TypeMerchantUserEnum;

    public typeCreatedEmployee: TypeMerchantUserEnum = this.menuTab.StoreEmployees;
    public showCreateEmployee: boolean = false;
    public isCreateEmployee: boolean = true;
    public showEditFields: boolean = false;

    public merchantId: any = this.appData.authData.MerchantId;

    public merchantUserRoles = MerchantUserRolesEnum;

    public handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        this.getStoreEmployees(skip);
    }

    public handlePopupLinkClick(user: any, showEditFields: boolean): void {
        console.log(user);
        if (user.RoleId === this.merchantUserRoles.Root) {
            this.typeCreatedEmployee = this.menuTab.WebAdmins;
        }
        else {
            this.typeCreatedEmployee = this.menuTab.StoreEmployees;
        }
        this.selectedUser = user;
        this.showEditFields = showEditFields;
        this.isCreateEmployee = false;
        this.showCreateEmployee = true;

    }

    public deleteMerchantUser(merchantUserId: number) {
        const dto = {
            MerchantUserId: merchantUserId,
        };

        this.merchantUserService.deleteMerchantUserById(dto, this.messageService)
            .then(data => {
                this.loading = false;

                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully deleted' });
                this.getStoreEmployees(0);
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    private getStoreEmployees(skip: number) {
        const dto = {
            MerchantId: this.appData.authData.MerchantId,
            GetAdmins: null,
            Skip: skip,
            SearchName: this.searchName,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder,
            StoreId: this.storeId
        };

        this.merchantUserService.getMerchantUsers(dto, this.messageService)
            .then(data => {
                this.loading = false;

                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.first = skip;
                this.totalRecords = data.TotalRecords;

                this.storeEmployees = data.Items.map((x: any) => {
                    x.CreatedAt = Utils.utcToLocaleDateString(x.CreatedAt) + ' ' + Utils.utcToLocaleTimeString(x.CreatedAt);
                    x.BirthdayStr = Utils.utcToLocaleDateString(x.Birthday);
                    x.Birthday = new Date(x.Birthday);
                    return x;
                });;
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public handleFilterChange(): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getStoreEmployees(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public handleShowCreateEmployee(tab: TypeMerchantUserEnum) {
        this.typeCreatedEmployee = tab;
        this.showCreateEmployee = true;
        this.showEditFields = true;
        this.isCreateEmployee = true;
    }

    public handleCreatePopupHide() {
        this.showCreateEmployee = false;
        this.getStoreEmployees(0);
    }
}
